import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { queryStatusFor } from '../utils/contentMode';

import { ContentModeQuery } from './ContentModeQuery.graphql';
import type {
	ContentModeQuery_content_PaginatedContentListWithChild_nodes_Content_contentProperties_ContentProperties_latest_PublishedContentProperties,
	ContentModeQueryVariables,
} from './__types__/ContentModeQuery';

export const preloadContentMode = ({
	contentId,
	isDraft,
	useCache = false,
	isArchived,
}: {
	contentId: ContentModeQueryVariables['contentId'];
	isDraft: ContentModeQueryVariables['isDraft'];
	useCache: boolean;
	isArchived?: boolean;
}) => {
	const status = queryStatusFor(isDraft, isArchived);

	return query<
		ContentModeQuery_content_PaginatedContentListWithChild_nodes_Content_contentProperties_ContentProperties_latest_PublishedContentProperties,
		ContentModeQueryVariables & { cacheBuster?: number }
	>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ContentModeQuery,
		variables: {
			contentId,
			isDraft,
			status: [status],
		},
		fetchPolicy: useCache ? 'cache-first' : 'network-only',
	});
};
